var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              staticClass: "searchForm",
              attrs: {
                model: _vm.queryForm,
                "label-position": "right",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "单据编号",
                                    prop: "reportNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "handle-input",
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryForm.reportNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryForm, "reportNo", $$v)
                                      },
                                      expression: "queryForm.reportNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "版本",
                                    prop: "includeHistory",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "handle-input",
                                      attrs: { placeholder: "请选择" },
                                      model: {
                                        value: _vm.queryForm.includeHistory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm,
                                            "includeHistory",
                                            $$v
                                          )
                                        },
                                        expression: "queryForm.includeHistory",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "含历史版本",
                                          value: "Y",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "最新", value: "N" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "产品",
                                    prop: "fiveBitCodeName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "handle-input",
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    on: {
                                      focus: _vm.showTemplateName,
                                      clear: _vm.clearFiveBitCodeName,
                                    },
                                    model: {
                                      value: _vm.queryForm.fiveBitCodeName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm,
                                          "fiveBitCodeName",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.fiveBitCodeName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Facility编号",
                                    prop: "supplierCode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "handle-input",
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryForm.supplierCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm,
                                          "supplierCode",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.supplierCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Facility名称",
                                            prop: "plantName",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "handle-input",
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value: _vm.queryForm.plantName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryForm,
                                                  "plantName",
                                                  $$v
                                                )
                                              },
                                              expression: "queryForm.plantName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "评估人",
                                            prop: "rater",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-autocomplete",
                                            {
                                              staticClass: "inline-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "fetch-suggestions":
                                                  _vm.querySearch,
                                                placeholder: "请输入内容",
                                                clearable: "",
                                              },
                                              model: {
                                                value: _vm.queryForm.rater,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryForm,
                                                    "rater",
                                                    $$v
                                                  )
                                                },
                                                expression: "queryForm.rater",
                                              },
                                            },
                                            [
                                              _c("el-button", {
                                                attrs: {
                                                  slot: "append",
                                                  icon: "el-icon-search",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.searchRater()
                                                  },
                                                },
                                                slot: "append",
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "生产日期(从)",
                                            prop: "beginDate",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                            },
                                            model: {
                                              value: _vm.queryForm.beginDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryForm,
                                                  "beginDate",
                                                  $$v
                                                )
                                              },
                                              expression: "queryForm.beginDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "生产日期(至)",
                                            prop: "endDate",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                            },
                                            model: {
                                              value: _vm.queryForm.endDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryForm,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression: "queryForm.endDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Sample Source",
                                            prop: "sampleSource",
                                          },
                                        },
                                        [
                                          _c("IcSelect", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              table: "TT_PROCESS_SENSORY",
                                              field: "SAMPLE_SOURCE",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.queryForm.sampleSource,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryForm,
                                                  "sampleSource",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryForm.sampleSource",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "确认状态",
                                            prop: "status",
                                          },
                                        },
                                        [
                                          _c("IcSelect", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              excludes: _vm.excludesValue,
                                              table: "TT_SENSORY",
                                              field: "REPORT_STATUS",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.queryForm.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryForm,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "queryForm.status",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.getData(1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.restQueryForm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.reset")))]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "action-btn-row" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.PROC_LOT_RECORD_VIEW,
                  expression: "PROC_LOT_RECORD_VIEW",
                },
              ],
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.exportList },
            },
            [_vm._v("总览报表")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.PROC_LOT_RECORD_VIEW,
                  expression: "PROC_LOT_RECORD_VIEW",
                },
              ],
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.onExport },
            },
            [_vm._v("详情报表")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.PROC_LOT_RECORD_VIEW,
                  expression: "PROC_LOT_RECORD_VIEW",
                },
              ],
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.onDetail },
            },
            [_vm._v("详情报告")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.PROC_LOT_RECORD_ADD,
                  expression: "PROC_LOT_RECORD_ADD",
                },
              ],
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.onChange },
            },
            [_vm._v("变更")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "dataList",
          attrs: {
            data: _vm.dataList,
            border: "",
            "highlight-current-row": "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              width: "56px",
              type: "selection",
              label: _vm.$t("common.select"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              fixed: "",
              label: "单据编号",
              prop: "reportNo",
              width: "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-link",
                      {
                        staticClass: "el-link",
                        on: {
                          click: function ($event) {
                            return _vm.toDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.reportNo))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "版本",
              prop: "version",
              "min-width": "70px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("v" + _vm._s(scope.row.version))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "产品",
              prop: "fiveBitCodeName",
              "min-width": "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "Facility编号",
              prop: "supplierCode",
              "min-width": "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "Facility名称",
              prop: "plantName",
              "min-width": "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "生产日期",
              prop: "prodDate",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormatFilter")(
                          scope.row.prodDate,
                          "YYYY-MM-DD"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "评估人",
              prop: "rater",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "Sample Source",
              prop: "sampleSource",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("ic")(
                          scope.row.sampleSource,
                          "TT_PROCESS_SENSORY",
                          "SAMPLE_SOURCE"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "单据状态",
              prop: "status",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("ic")(
                          scope.row.status,
                          "TT_SENSORY",
                          "REPORT_STATUS"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "备注",
              prop: "remark",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "模板名称",
              prop: "templateName",
              width: "150px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "模板版本",
              prop: "templateVersion",
              width: "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "是否变更",
              prop: "changed",
              formatter: _vm.formatChangedStatus,
              width: "180px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "创建人",
              prop: "creator",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "创建日期",
              prop: "createDate",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormatFilter")(
                          scope.row.createDate,
                          "YYYY-MM-DD"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "更新人",
              prop: "creator",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              label: "更新日期",
              prop: "createDate",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormatFilter")(
                          scope.row.updateDate,
                          "YYYY-MM-DD"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.queryForm.status == "CANCLE"
            ? _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: "禁用原因",
                  prop: "inactiveReason",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "page-sizes": [10, 15, 50, 100],
              "page-size": _vm.queryForm.pageSize,
              "current-page": _vm.queryForm.pageNum,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": function ($event) {
                return _vm.pageSizeChange($event, "queryForm", "getData")
              },
              "current-change": function ($event) {
                return _vm.pageNumberChange($event, "queryForm", "getData")
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showRaterDialog,
            "append-to-body": "",
            width: "80%",
            title: "评估人选择器",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRaterDialog = $event
            },
          },
        },
        [
          _c("pickupUser", {
            attrs: { multi: true },
            on: { input: _vm.selectRater },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showTemplateNameDialog,
            "append-to-body": "",
            width: "80%",
            title: "产品选择器",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showTemplateNameDialog = $event
            },
          },
        },
        [
          _vm.TemplateNameDialogReset
            ? _c("PickupFiveBitCode", {
                on: { pickup: _vm.selectTemplateName },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.changeDialog,
            "append-to-body": "",
            width: "70%",
            title: "变更品评报告",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.changeDialog = $event
            },
          },
        },
        [_vm.changeDialog ? _c("changeDialog") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }